module.exports = __webpack_public_path__ + "static/media/ml-semantic-segmentation.8f4eba9f.gif";